module.exports = __webpack_public_path__ + "img/font_1.8ceb5121.webp";